/**
 * Shown while the boot restore is in flight.
 *
 * It exists so neither the login form nor a guarded screen renders on a session we
 * have not finished asking about — without it, every reload flashes `/login` at an
 * already-authenticated user and then redirects them away again.
 */
export function TelaDeEspera() {
  return (
    <main className="bg-page flex min-h-dvh items-center justify-center">
      <p role="status" className="text-text-muted type-body">
        Carregando…
      </p>
    </main>
  )
}
